// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1YbUn","footer":"ReportModalFilter_footer__NJ8HD"};